export const DEFAULT_NAV_LABELS = {
    home: 'Home',
    commission: 'Commission',
    meetings: 'Meetings',
    boards: 'Boards',
    topics: 'Topics',
    documents: 'Official Actions',
};
export const DEFAULT_PAGE_HEADINGS = {
    commission: {
        title: 'Insert Heading text here',
        subtitle: 'Insert Subheader text here',
    },
    meetings: {
        title: 'Insert Heading text here',
        subtitle: 'Insert Subheader text here',
    },
    topics: {
        title: 'Insert Heading text here',
        subtitle: 'Insert Subheader text here',
    },
    boards: {
        title: 'Insert Heading text here',
        subtitle: 'Insert Subheader text here',
    },
    documents: {
        title: 'Insert Heading text here',
        subtitle: 'Insert Subheader text here',
    },
};
export const DEFAULT_MEETING_CONFIG = {
    votes: {
        aye: 'Aye',
        nay: 'No',
        abstain: 'Abstain',
        recuse: 'Recuse',
        absent: 'Absent',
    },
    speakerTimer: {
        fullsize: false,
        finishSoundUrl: null,
        presets: [
            {
                defaultSeconds: 120,
                firstThreshold: 30,
                secondThreshold: 10,
            },
            {
                defaultSeconds: 60,
                firstThreshold: 20,
                secondThreshold: 10,
            },
        ],
        addTimeOptions: [30, 60, 120],
    },
    publicSpeakers: {
        enabled: false,
        defaultSeconds: 60,
        signupOpenThreshold: 1800,
        signupCloseThreshold: 0,
    },
    publicComments: {
        enabled: false,
        allowAttachments: false,
        signupCloseThreshold: 0,
    },
    display: {
        theme: 'dark',
        background: {
            url: null,
            opacity: 60,
            grayscale: false,
            invert: false,
            size: 'contain',
        },
        showRecommendedAction: true,
        showMotionMade: true,
        motionResultsTime: 30,
    },
};
export const TimezoneValues = {
    Hawaii: 'Pacific/Honolulu', // Hawaii Time
    Alaska: 'America/Anchorage', // Alaska Time
    Pacific: 'America/Los_Angeles', // Pacific Time
    Mountain: 'America/Denver', // Mountain Time
    MountainAz: 'America/Phoenix', // Mountain Time (Arizona)
    Central: 'America/Chicago', // Central Time
    Eastern: 'America/New_York', // Eastern Time
    UTC: 'UTC', // UTC Time
};
export const TimezoneAbbreviations = {
    [TimezoneValues.Hawaii]: 'HST', // Hawaii Time
    [TimezoneValues.Alaska]: 'AKT', // Alaska Time
    [TimezoneValues.Pacific]: 'PT', // Pacific Time
    [TimezoneValues.Mountain]: 'MT', // Mountain Time
    [TimezoneValues.MountainAz]: 'MST', // Mountain Time (Arizona)
    [TimezoneValues.Central]: 'CT', // Central Time
    [TimezoneValues.Eastern]: 'ET', // Eastern Time
    [TimezoneValues.UTC]: 'UTC', // UTC Time
};
